import { RULES } from "./helpers";
import { Trophy, RefreshCw, Target, Scale } from "lucide-react";

const toneMap = {
  emerald: "from-emerald-500/20 to-emerald-500/5 border-emerald-500/40 text-emerald-400",
  blue: "from-blue-500/20 to-blue-500/5 border-blue-500/40 text-blue-400",
  amber: "from-amber-500/20 to-amber-500/5 border-amber-500/40 text-amber-400",
  rose: "from-rose-500/20 to-rose-500/5 border-rose-500/40 text-rose-400",
};

export function RulesView() {
  return (
    <div className="space-y-6" data-testid="rules-view">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-400">
          Regolamento
        </div>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-white">
          Come Funziona l'Americana
        </h2>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {RULES.map((r) => (
          <div
            key={r.label}
            className={`rounded-2xl border bg-gradient-to-b p-5 ${toneMap[r.tone]}`}
          >
            <div className="font-mono font-black text-5xl mb-1">{r.pts}</div>
            <div className="text-xs uppercase tracking-wider text-slate-400 mb-0.5">punti</div>
            <div className="font-semibold text-white">{r.label}</div>
          </div>
        ))}
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <div className="ap-card p-5">
          <RefreshCw className="w-6 h-6 text-emerald-400 mb-3" />
          <h3 className="font-display uppercase tracking-wide text-white mb-1.5">Coppie a rotazione</h3>
          <p className="text-sm text-slate-400 leading-relaxed">
            12 giocatori, 3 campi. Ad ogni giornata i compagni cambiano: vince chi è più forte
            indipendentemente dal partner.
          </p>
        </div>
        <div className="ap-card p-5">
          <Target className="w-6 h-6 text-blue-400 mb-3" />
          <h3 className="font-display uppercase tracking-wide text-white mb-1.5">Punteggio individuale</h3>
          <p className="text-sm text-slate-400 leading-relaxed">
            I punti della partita vengono assegnati ad entrambi i giocatori della coppia e sommati
            nella classifica personale.
          </p>
        </div>
        <div className="ap-card p-5">
          <Scale className="w-6 h-6 text-amber-400 mb-3" />
          <h3 className="font-display uppercase tracking-wide text-white mb-1.5">Spareggi</h3>
          <p className="text-sm text-slate-400 leading-relaxed">
            A parità di punti conta il minor numero di games subiti, poi la differenza games
            complessiva.
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 rounded-2xl border border-amber-500/30 bg-amber-500/5 p-4">
        <Trophy className="w-5 h-5 text-amber-400 shrink-0" />
        <p className="text-sm text-amber-100/80">
          Le posizioni a premio vengono calcolate automaticamente dopo ogni risultato inserito
          dall'amministratore.
        </p>
      </div>
    </div>
  );
}
